// src/App.js
import React, { useEffect, useState, useCallback } from 'react';
import AppRouter from './router/AppRouter';
import './styles/App.css';
import { ToastProvider } from './contexts/ToastContext';
import autoPrintService from './services/AutoPrintService';
import LicenciaBlockScreen from './components/common/LicenciaBlockScreen';
import UpdateBlockScreen from './components/common/UpdateBlockScreen';
import { getApiUrl, waitForApiUrl } from './utils/api';

const VERIFICACION_INTERVALO = 6 * 60 * 60 * 1000; // 6 horas

function App() {
  const [licenciaValida, setLicenciaValida] = useState(null); // null = verificando
  const [mensajeBloqueo, setMensajeBloqueo] = useState('');
  const [updateInfo, setUpdateInfo] = useState(null);

  const verificarLicencia = useCallback(async () => {
    try {
      // Esperar a que la URL del api_url.txt esté cargada
      const API_LOCAL = await waitForApiUrl();

      // Obtener machine_id desde Electron
      let machineId = 'web-' + navigator.userAgent.length + '-' + (navigator.hardwareConcurrency || 0);
      if (window.licenciaAPI) {
        const machineResult = await window.licenciaAPI.getMachineId();
        if (machineResult.success) {
          machineId = machineResult.machineId;
        }
      }

      // Verificar contra la API local (que internamente verifica con el servidor remoto)
      const response = await fetch(API_LOCAL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tipo: 'verificarLicencia',
          machine_id: machineId
        })
      });

      const result = await response.json();

      if (result.success) {
        setLicenciaValida(true);
      } else {
        setLicenciaValida(false);
        setMensajeBloqueo(result.message);
      }

    } catch (error) {
      console.error('Error verificando licencia:', error);
      setLicenciaValida(false);
      setMensajeBloqueo('No se pudo conectar a la API local. Verifique que el servidor esté corriendo.');
    }
  }, []);

  useEffect(() => {
    verificarLicencia();

    const intervalo = setInterval(verificarLicencia, VERIFICACION_INTERVALO);

    // Escuchar eventos de actualización desde Electron
    let removeListener = null;
    if (window.updaterAPI) {
      removeListener = window.updaterAPI.onUpdateStatus((data) => {
        console.log('Update status:', data.status, data);
        if (data.status === 'available' || data.status === 'downloading' || data.status === 'downloaded') {
          setUpdateInfo(data);
        } else if (data.status === 'not-available') {
          setUpdateInfo(null);
        } else if (data.status === 'error') {
          setUpdateInfo(data);
          setTimeout(() => setUpdateInfo(null), 5000);
        }
      });
    }

    autoPrintService.iniciar();
    return () => {
      clearInterval(intervalo);
      if (removeListener) removeListener();
      autoPrintService.detener();
    };
  }, [verificarLicencia]);

  // Actualización tiene prioridad sobre todo
  if (updateInfo && updateInfo.status !== 'error') {
    return <UpdateBlockScreen updateInfo={updateInfo} />;
  }

  // Mientras verifica licencia, mostrar pantalla de carga
  if (licenciaValida === null) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#1a1a2e', color: 'white', fontSize: '16px' }}>
        Verificando licencia...
      </div>
    );
  }

  // Si la licencia no es válida, bloquear
  if (!licenciaValida) {
    return (
      <LicenciaBlockScreen
        mensaje={mensajeBloqueo}
        onLicenciaActivada={() => {
          setLicenciaValida(true);
        }}
      />
    );
  }

  return (
    <div className="App">
      <ToastProvider><AppRouter /></ToastProvider>
    </div>
  );
}

export default App;
